export default __webpack_public_path__ + "static/media/moonpay_walkthrough_4.6b8055fa.bin";